import React from "react";
import { ElementsConsumer } from "@stripe/react-stripe-js";

import CheckoutForm from "./CheckOutForm";

const InjectedCheckoutForm = (props) => (
  <ElementsConsumer>
    {({ stripe, elements }) => (
      <CheckoutForm
        stripe={stripe}
        elements={elements}
        onSubmit={(token, recaptchaValue) => props.onSubmit(token, recaptchaValue)}
      />
    )}
  </ElementsConsumer>
);

export default InjectedCheckoutForm;



// WEBPACK FOOTER //
// ./src/layout/stripe/InjectedCheckoutForm.js